import { BufferCalculationType } from 'business/BufferCalculationType';
import { ExtendedIngredientDTO } from 'business/models/Models';
import RMButton from 'components/customComponents/Controls/RMButton';
import { cloneDeep } from 'lodash';
import React, { ChangeEvent } from 'react';
import { MergeIngredientSectionProps } from '../IngredientConstants';
import { MergeIngredientItemsList } from './MergeIngredientItemsList';
import { Input } from 'components/input';
import { MergeIngredientInputs } from './MergeIngredientInputs';
import { MergeIngredientType } from '../IngredientEnums';
import { AddMergeIngredientProps } from './MergeIngredientConstants';
import { FmlxButton } from 'fmlx-common-ui';

export const MergeIngredientSection = (props: MergeIngredientSectionProps) => {
  const {
    ingredient,
    onClickAdd,
    onClickDelete,
    heading,
    buttonText,
    onClickButton,
    showButtons,
    tempIngredient,
    setTempIngredient,
    mergeIngredientType,
    setMergeIngredientType,
    currentMergeIngredientType,
    setMergeIngredient,
  } = props;
  const onFocusBufferData = () => {
    if (currentMergeIngredientType !== MergeIngredientType.MergeIngredient) {
      const ing = new ExtendedIngredientDTO();
      ing.bufferCalculationTypeId = ingredient.bufferCalculationTypeId;
      if (ing.bufferCalculationTypeId === BufferCalculationType.pKa.ID) {
        ing.pKa = ingredient.pKa;
        ing.bufferDataPoint = [];
      } else {
        ing.bufferDataPoint = ingredient.bufferDataPoint;
      }
      setTempIngredient(cloneDeep(ing));
    }
  };
  const addMergeIngredient: AddMergeIngredientProps = {
    ing: tempIngredient,
    property: '',
    mergeIngredient: ingredient,
    setMergeIngredient: setMergeIngredient,
    setTempIngredient: setTempIngredient,
  };
  const inputFields = {
    initialInputs: [
      {
        tableHeading: 'ID',
        onClickAddBtn: (e) => {
          const mergeIngredient = addMergeIngredient.mergeIngredient;
          mergeIngredient.ingredientStock = addMergeIngredient?.ing?.ingredientStock;
          addMergeIngredient.mergeIngredient = mergeIngredient;
          addMergeIngredient.property = 'id';
          onClickAdd(cloneDeep(addMergeIngredient));
        },
        onClickRemoveBtn: (e) => {
          const ing = ingredient;
          ing.id = null;
          onClickDelete(cloneDeep(ing));
        },
        showButtons: showButtons,
        onFocus: (e: ChangeEvent<HTMLInputElement>) => {
          if (currentMergeIngredientType !== MergeIngredientType.MergeIngredient) {
            const ing = new ExtendedIngredientDTO();
            ing.id = +e.target.value;
            if (ing.id === ingredient.id) {
              ing.ingredientStock = ingredient.ingredientStock;
            }
            setTempIngredient(cloneDeep(ing));
          }
        },
        value: ingredient.id,
        placeHolder: '',
        error:
          currentMergeIngredientType === MergeIngredientType.MergeIngredient
            ? ' *Required'
            : '',
      },
      {
        tableHeading: 'Name',
        onClickAddBtn: (e) => {
          addMergeIngredient.property = 'longName';
          onClickAdd(cloneDeep(addMergeIngredient));
        },
        onClickRemoveBtn: (e) => {
          const ing = ingredient;
          ing.longName = '';
          onClickDelete(cloneDeep(ing));
        },
        showButtons: showButtons,
        onFocus: (e: ChangeEvent<HTMLInputElement>) => {
          if (currentMergeIngredientType !== MergeIngredientType.MergeIngredient) {
            const ing = new ExtendedIngredientDTO();
            ing.longName = e.target.value;
            setTempIngredient(cloneDeep(ing));
          }
        },
        value: ingredient.longName,
        placeHolder: '',
        require: true,
        error:
          currentMergeIngredientType === MergeIngredientType.MergeIngredient
            ? ' *Required'
            : '',
      },
      {
        tableHeading: 'Short Name',
        onClickAddBtn: (e) => {
          addMergeIngredient.property = 'shortName';
          onClickAdd(cloneDeep(addMergeIngredient));
        },
        onClickRemoveBtn: (e) => {
          const ing = ingredient;
          ing.shortName = '';
          onClickDelete(cloneDeep(ing));
        },
        showButtons: showButtons,
        onFocus: (e: ChangeEvent<HTMLInputElement>) => {
          if (currentMergeIngredientType !== MergeIngredientType.MergeIngredient) {
            const ing = new ExtendedIngredientDTO();
            ing.shortName = e.target.value;
            setTempIngredient(cloneDeep(ing));
          }
        },
        value: ingredient.shortName,
        placeHolder: '',
        require: true,
        error:
          currentMergeIngredientType === MergeIngredientType.MergeIngredient
            ? ' *Required'
            : '',
      },
    ],
    bufferFields: {
      tableHeading: 'Buffer Collection',
      onClickAddBtn: (e) => {
        addMergeIngredient.property = 'bufferCalculationTypeId';
        onClickAdd(cloneDeep(addMergeIngredient));
      },
      onClickRemoveBtn: (e) => {
        const ing = ingredient;
        ing.bufferCalculationTypeId = null;
        ing.pKa = null;
        ing.bufferDataPoint = [];
        onClickDelete(cloneDeep(ing));
      },
      showButtons: showButtons,
      onFocus: (e: ChangeEvent<HTMLInputElement>) => {
        if (currentMergeIngredientType !== MergeIngredientType.MergeIngredient) {
          const ing = new ExtendedIngredientDTO();
          ing.longName = e.target.value;
          setTempIngredient(cloneDeep(ing));
        }
      },
      value:
        ingredient?.bufferCalculationTypeId === BufferCalculationType.pKa.ID
          ? 'pKa'
          : ingredient?.bufferDataPoint?.length > 0
          ? 'interpolate'
          : '',
      placeHolder: '',
    },
  };
  return (
    <>
      <div
        id="mergeingredientsection-heading-container"
        className="flex flex-direction-row justify-between"
      >
        <span id={`mergeingredientsection-${heading}`}>{heading}</span>
        <RMButton
          onClick={() => onClickButton(currentMergeIngredientType)}
          label={buttonText}
          type={FmlxButton.Type.POSITIVE}
        ></RMButton>
      </div>
      <hr id="mergeingredientsection-divider" className="hr-line" />

      {inputFields.initialInputs.map((inputField) => {
        return (
          <>
            <div
              id={`mergeingredientsection-initialinput-${inputField}`}
              className="ingredient-input-container"
            >
              <MergeIngredientInputs inputField={inputField}></MergeIngredientInputs>
            </div>
          </>
        );
      })}

      <div id="mergeingredientsection-aliases">
        <MergeIngredientItemsList
          name="Aliases"
          iterator={ingredient.aliases}
          selectedIteratorItems={tempIngredient.aliases}
          onClickAdd={onClickAdd}
          onClickDelete={onClickDelete}
          showButtons={showButtons}
          propertyName="aliases"
          currentMergeIngredientType={currentMergeIngredientType}
          ingredient={ingredient}
          mergeIngredientType={mergeIngredientType}
          setMergeIngredientType={setMergeIngredientType}
          tempIngredient={tempIngredient}
          setTempIngredient={setTempIngredient}
          setMergeIngredient={setMergeIngredient}
        ></MergeIngredientItemsList>
      </div>
      <div id="mergeingredientsection-casnumbers">
        <MergeIngredientItemsList
          name="CAS#"
          iterator={ingredient.casnumbers}
          selectedIteratorItems={tempIngredient.casnumbers}
          onClickAdd={onClickAdd}
          onClickDelete={onClickDelete}
          showButtons={showButtons}
          propertyName="casnumbers"
          currentMergeIngredientType={currentMergeIngredientType}
          ingredient={ingredient}
          mergeIngredientType={mergeIngredientType}
          setMergeIngredientType={setMergeIngredientType}
          tempIngredient={tempIngredient}
          setTempIngredient={setTempIngredient}
          setMergeIngredient={setMergeIngredient}
        ></MergeIngredientItemsList>
      </div>
      <div id="mergeingredientsection-types">
        <MergeIngredientItemsList
          name="Type"
          iterator={ingredient.types}
          selectedIteratorItems={tempIngredient.types}
          onClickAdd={onClickAdd}
          onClickDelete={onClickDelete}
          showButtons={false}
          propertyName="types"
          currentMergeIngredientType={currentMergeIngredientType}
          ingredient={ingredient}
          mergeIngredientType={mergeIngredientType}
          setMergeIngredientType={setMergeIngredientType}
          tempIngredient={tempIngredient}
          setTempIngredient={setTempIngredient}
          setMergeIngredient={setMergeIngredient}
        ></MergeIngredientItemsList>
      </div>
      <div>
        <div
          id="mergeingredientsection-bufferfields"
          className="ingredient-input-container"
        >
          <MergeIngredientInputs
            inputField={inputFields.bufferFields}
          ></MergeIngredientInputs>
        </div>
      </div>
      <div id="mergeingredientsection-pka-container">
        <Input
          id="mergeingredientsection-pka-input"
          className="ingredient-pka-field"
          onFocus={() => onFocusBufferData()}
          value={ingredient?.pKa ?? ''}
          placeHolder="pKa"
        ></Input>
        <div
          id="mergeingredientsection-bufferlist"
          className="wizard-list incoming-ingredients-list"
          onClick={() => onFocusBufferData()}
        >
          {ingredient?.bufferDataPoint?.map((bufferData) => {
            return (
              <div
                id="mergeingredientsection-bufferdata"
                key={`buffer-data-${bufferData.id}`}
                className={`ingredient-wizard-list-item wizard-list-item`}
              >
                {bufferData.ph}, {bufferData.ratio}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
